
import Table from './Table';
const Tab2 = ({setSelectedCompanyAccounts}) => {

  return (
   <div
      className="row mb-3"
      style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Default Payable Account</p>
        <Table 
        setSelectedCompanyAccounts={setSelectedCompanyAccounts}
        />
      </div>
    </div>
  )
}

export default Tab2